module.exports = __webpack_public_path__ + "static/basen-woda-02a126a2bd3506755f1a24437e8bbd4a.jpg";